import React, { useContext } from 'react';
import { WidthContext } from '../../WidthContext';
import './infographics.scss';
// import { useTranslation } from 'react-i18next';
import InfographicHead from './InfographicHead';
// import { infographicData } from './infographicsData';
import Infographic2 from './Infographic2';
import Infographic1 from './Infographic1';
import { lang } from '../lang';

function Infographics({ index }) {
  // const { t } = useTranslation();
  const { viewSize } = useContext(WidthContext);

  return (
    <div className={`infographics infographics-${index}`}>
      {viewSize === 'small' && index === 1 ? <></> : <InfographicHead index={index} />}
      <div
        className={`infographics__divider infographics__divider-${index} ${lang.infographic[index].color}gradient`}
      />
      <p className={`infographics__subhead infographics__subhead-${index}`}>
        {lang.infographic[index].subhead}
      </p>
      {index === 0 ? <Infographic1 /> : <Infographic2 />}
    </div>
  );
}

export default Infographics;
